import script from "./VideoComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoComponente.vue?vue&type=script&setup=true&lang=js"

import "./VideoComponente.vue?vue&type=style&index=0&id=8085beac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8085beac"]])

export default __exports__